import { RenewOutboxRecordDto } from '../dtos/renew-outbox-record.dto';

/**
 * Renew outbox records response DTO
 */
export class RenewOutboxRecordsResponse {
	records!: RenewOutboxRecordDto[];
}
